import { toast } from 'vuetify-sonner';

export function showMessage(
    message: string,
    showCloseButton: boolean = false,
    color: string = 'toastLightGreen',
    opacity: number = 1,
    duration: number = 3000,
    top: boolean = false,
    left: boolean = false,
    right: boolean = false,
    icon: string | null = null
) {
    let position = 'bottom-center';
    if (top && right) {
        position = 'top-right';
    } else if (top && left) {
        position = 'top-left';
    } else if (top) {
        position = 'top-center';
    }

    let options: any = {
        duration: duration,
        position: position,
        cardProps: {
            color: color,
            class: 'tb-toast',
            style: {
                opacity: opacity,
            },
        },
        prependIcon: icon,
    };

    if (showCloseButton) {
        options.cardProps.class += ' compact';
        //here we have small issue with VSonner. To render HTML we can use only description
        options.description = message;
        message = '';

        options['action'] = {
            label: 'close',
            buttonProps: {
                color: 'white',
                density: 'default',
                //     icon: 'mdi-arrow-right-bold',
            },
        };
    }

    //https://github.com/xiaoluoboding/vue-sonner/issues/98
    setTimeout(() => {
        toast(message, options);
    }, 100);
    // if (isString(messages)) {
    //     messages = {
    //         message: messages,
    //         showCloseButton: showCloseButton,
    //         color: color,
    //         timeout: timeout,
    //         top: top,
    //         bottom: bottom,
    //         left: left,
    //         right: right,
    //         icon: icon,
    //         contentClass: '',
    //     };
    // }
    //
    // store.commit('AppModule/setMessages', messages);
}
export function newBetMessage(message: string) {
    showMessage(message, true, 'toastGreen', 0.95, 5000, true, false, true, mdiReceiptTextCheckOutline);
}
export function newBetWaitingMessage(message: string) {
    showMessage(message, true, 'toastLightOrange', 0.95, 5000, true, false, true, mdiReceiptTextClockOutline);
}
export function orderClosedMessage(message: string, color: string, opacity: number) {
    showMessage(message, true, color, opacity, 5000, true, false, true, mdiClipboardClockOutline);
}
export function failMessage(message: string) {
    showMessage(message, false, 'toastLightRed', 0.9, 3000, false, false, false, mdiAlertCircleOutline);
}
export function successMessage(message: string) {
    showMessage(message, false, 'toastLightGreen', 0.9, 3000, false, false, false, mdiCheckboxMarkedCircle);
}
